import { Attribute, Component, Convention } from '../../../concepts/objects';
import { Polyline } from '../../../platform/geom/Polyline';
import { UniversalSurfaceRenderer } from '../../../platform/UniversalSurfaceRenderer';
import { Physical } from '../entities/Physical';

export const Graffiti = new Convention<Graffiti>('Graffiti');

export interface Graffiti extends Component {
    readonly origin: 'topLeft' | 'center';
    outline(): Polyline;
    paintTo(ctx: UniversalSurfaceRenderer): void;
}

export const GraffitiAttr = new Attribute<HTMLElement>('graffiti');

export const GraffitiTarget = new Convention<Physical>('GraffitiTarget');
